<template>
  <div>
    <el-container style="background-color: #DCDCDC; height: 733px">
      <el-header class="el-header">
        <strong style="font-size: 24px;" >上传评分数据<br>
          Upload scores
        </strong>
        <div style="margin-top: 10px; margin-left: 700px">

        </div>
      </el-header>
      <el-main class="el-main">
        <div style="justify-content: right; margin-left: 600px">
          <el-button type="primary" @click="$router.push('/Researcherindex')" >返回<br><br>
            Return
          </el-button>
        </div>
        <div>
        <el-button  class="butten_upload" type="primary" @click="generate_template" :disabled="generate">
              生成评分模板<br><br>
          Generate rating template
        </el-button>
        </div>
        <div>
        <el-button  class="butten_upload" type="primary" @click="download_template" :disabled="!download">
              下载评分模板<br><br>
          Download rating template
        </el-button>
        </div>
        <div>
          <el-upload
              class="upload-demo"
              auto-upload="True"
              action="https://www.tall-webtest.com/studytest-0.0.1-SNAPSHOT/uploadExcel/importRecordInfo"
              :on-change="handleChange"
              show-file-list
          >
            <el-button  class="butten_upload" type="primary" :disabled="!upload">
              上传评分
              <br><br>
              Upload rating template
            </el-button>
            <div slot="tip" class="el-upload__tip">只能上传xlsx文件，且不超过500kb Only .xlsx files not exceeding 500kb can be upload</div>
          </el-upload>
        </div>
      </el-main>





    </el-container>
  </div>
</template>

<script>
import GLOBAL from "../../plugins/global_variable";

export default {
  name: "Researcherupload",
  data(){
    return{
      generate : false,
      upload: false,
      download: false,
      Reemail: GLOBAL.Reemail,
      // Reemail: '123@qq.com'

    }
  },
  methods:{
    generate_template() {
      this.download = true
      axios({
        url: "/uploadExcel/generateTemplate?remail=" + this.Reemail,
        responseType: 'blob'
      }).then((resp)=>{
        console.log(resp.data)
      })
      console.log("!")

    },

    download_template(){
      this.upload = true
      let fileName = "rating_template.xls"
      axios({
        url: "/uploadExcel/downloadTemplate?remail=" + this.Reemail,
        responseType: 'blob'
      }).then((response) => {
        if ('download' in document.createElement('a')) { // 非IE下载
          const content = response.data
          const blob = new Blob([content])
        const elink = document.createElement('a')
        elink.download = fileName
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href) // 释放URL 对象
        document.body.removeChild(elink)
        this.generate = !this.generate

      } else { // IE10+下载
        navigator.msSaveBlob(blob, fileName)
      }
      })
    },


    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },



  }

}
</script>

<style scoped>
.el-header{
  margin-top: 10px;
  text-align: center;

}

.butten_upload{
  width: 300px;
  height: 100px;
  font-size: 16px;
  margin-top: 20px;

}

.el-main{
  justify-content: center;
  text-align: center;
  margin-top: 20px;
}


</style>